// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___2a09ae9e0f6876bd5ce","cls2":"AccountMenu-cls2__b7f2e04f2511efaa7776 AccountMenu-cls1___2a09ae9e0f6876bd5ce"};